import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { BrandLogo } from "../../components/BrandLogo";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showTest, setShowTest] = useState(false);
  useEffect(() => {
    api.get("/settings/public").then((r) => setShowTest(!r.data?.admin_setup_complete)).catch(() => {});
  }, []);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      localStorage.setItem("mm_admin_token", r.data.token);
      localStorage.setItem("mm_admin_email", r.data.email);
      navigate("/admin");
    } catch (e) { toast.error(e?.response?.data?.detail || "Login failed."); setLoading(false); }
  };
  return (
    <div className="min-h-dvh hero-wash">
      <div className="mx-auto max-w-sm px-4 py-12">
        <div className="flex justify-center"><BrandLogo size={56} /></div>
        <div className="mt-6 rounded-[1.2rem] border bg-card p-6 shadow-[var(--shadow-soft)]">
          <div className="flex items-center gap-2"><Lock className="h-5 w-5" style={{ color: "hsl(var(--brand-rose))" }} /><h1 className="font-display text-xl font-semibold" style={{ color: "hsl(var(--brand-brown))" }}>Moments Made Admin</h1></div>
          <form onSubmit={submit} className="mt-5 space-y-4">
            <div><Label htmlFor="email">Email</Label><Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl" data-testid="admin-login-email-input" /></div>
            <div><Label htmlFor="password">Password</Label><Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-xl" data-testid="admin-login-password-input" /></div>
            <Button type="submit" disabled={loading} data-testid="admin-login-submit-button" className="h-12 w-full rounded-xl">{loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null} Sign in</Button>
          </form>
          {showTest && (
            <p data-testid="admin-test-access" className="mt-4 rounded-lg bg-[hsl(var(--muted))] p-3 text-[11px] text-[hsl(var(--muted-foreground))]">Test access: <b>admin@magnets.test</b> / <b>Magnets2026!</b><br />Change your email &amp; password in Settings to secure your account (this box will disappear).</p>
          )}
        </div>
      </div>
    </div>
  );
}
